import Component from "core/ts/system/Component";
import ColorItem from "components/ColorItem";

export default class ColorItemCanvasStrokeToForeground extends ColorItem {
    protected foregroundChange(color: string): void {
        (this.getElement() as HTMLCanvasElement).getContext('2d').strokeStyle = color;
    }
}